import React from 'react';

const AJAX_Request = () => {
  return (
    <div >
      <h1>AJAX_Request</h1>
      <p>Placeholder component for: "AJAX Request"</p>
    </div>
  );
};

export default AJAX_Request;
